import { IonButton, IonLabel, IonText } from '@ionic/react';

import HScrollContainer from '../../../layouts/HScrollContainer';

import './Categories.css';

interface Props {
    items: []
}

const Categories: React.FC<Props> = (props) => {
    return <HScrollContainer>
        {props.items?.map((item: any) => {
            return <IonButton key={`category_${item.id}`} className="category-item" routerLink={`/category/${item.id}`}>
                <IonText>{item.name}</IonText>
                <IonLabel>{item.projects}</IonLabel>
            </IonButton>
        })}
    </HScrollContainer>
}

export default Categories